import { PropertyGrid, Pane, NumericInput, Checkbox, Slider } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import React from 'react';
import { ns } from '@leverege/i18n';
import BandScaleModel from "../../models/scale/BandScaleModel.js";
const {
  t
} = ns('ui-attributes-graphs.editors.BandScaleEditor');
export default function BandScaleEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(BandScaleModel, props);
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "scaleEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('innerPadding')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    float: true,
    min: 0,
    max: 1,
    value: BandScaleModel.getPaddingInner(value),
    onChange: onModelChange,
    eventData: "setPaddingInner"
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('outerPadding')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    float: true,
    min: 0,
    max: 1,
    value: BandScaleModel.getPaddingOuter(value),
    onChange: onModelChange,
    eventData: "setPaddingOuter"
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('align')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    float: true,
    min: 0,
    max: 1,
    value: BandScaleModel.getAlign(value),
    onChange: onModelChange,
    eventData: "setAlign"
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('integerTicks'),
      value: BandScaleModel.getIntegerTicks(value),
      eventData: "setIntegerTicks",
      onChange: onModelChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('round'),
      value: BandScaleModel.getRound(value),
      eventData: "setRound",
      onChange: onModelChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('reverse'),
      value: BandScaleModel.getReverse(value),
      eventData: "setReverse",
      onChange: onModelChange
    })
  }));
}